import Vue from "vue";
import Vuex from "vuex";

import preloader from "./modules/preloader";
import newOrder from "./modules/newOrder";
import professionalsSuggestion from "./modules/professionalsSuggestion";
import addresses from "./modules/addresses";
import orders from "./modules/orders";
import subscriptions from "./modules/subscriptions";
import professionals from "./modules/professionals";
import user from "./modules/user";
import menu from "./modules/menu";
import physicals from "./modules/physicals";
import legals from "./modules/legals";
import states from "./modules/states";
import cities from "./modules/cities";
import districts from "./modules/districts";
import payments from "./modules/payments";
import coupons from "./modules/coupons";
import cycles from "./modules/cycles";
import newAddress from "./modules/newAddress";
import signUp from "./modules/signUp";
import RDStation from "./modules/RDStation";
import freshdesk from "./modules/freshdesk";
import accountTermsOfUse from "./modules/accountTermsOfUse";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    preloader,
    newOrder,
    professionalsSuggestion,
    addresses,
    orders,
    subscriptions,
    professionals,
    user,
    menu,
    physicals,
    legals,
    states,
    cities,
    districts,
    payments,
    coupons,
    cycles,
    newAddress,
    signUp,
    RDStation,
    freshdesk,
    accountTermsOfUse
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js